// Created by hejikun on 2017/11/2 0002.
let ask = [
  {
    path: '/ask',
    name: '在线咨询',
    component: () => import('@/pages/ask2')
    // component: () => import('@/pages/ask/ask')
  },
  {
    path: '/ask_order',
    name: '支付',
    component: () => import('@/pages/ask/ask_pay_order')
  },
  // 医师
  {
    path: '/ask_doctor_group_list',
    name: '医师团队列表',
    component: () => import('@/pages/ask2/ask2Doctor/ask2DoctorList.vue')
  },
  {
    path: '/ask_all_list',
    name: '专家免费咨询',
    component: () => import('@/pages/ask/ask_all_list')
  },
  {
    path: '/ask_doctor_recommend',
    name: '推荐专家',
    component: () => import('@/pages/ask/ask_doctor_recommend')
  },
  {
    path: '/ask_doctor_active',
    name: '活跃医师列表',
    component: () => import('@/pages/ask/ask_doctor_active')
  },
  {
    path: '/ask_more_special_column',
    name: '更多专栏',
    component: () => import('@/pages/ask/ask_more_special_column')
  },
  {
    path: '/ask_comment_list',
    name: '评论列表',
    component: () => import('@/pages/ask/ask_comment_list')
  },
  {
    path: '/ask_doctor_detail',
    name: '医师详情',
    component: () => import('@/pages/ask/ask_doctor_detail')
  },
  {
    path: '/ask_doctor_detail_new',
    name: '医生详情',
    component: () => import('@/pages/ask2/ask2Doctor/ask2DoctorDetail.vue')
  },
  {
    path: '/ask_consult_new',
    name: '病例填写',
    component: () => import('@/pages/ask/ask_consult_new')
  },
  {
    path: '/ask_more_depments',
    name: '更多科室',
    component: () => import('@/pages/ask/ask_more_depments')
  },
  // 问题
  {
    path: '/ask_question_list',
    name: '公开问题列表',
    component: () => import('@/pages/ask/ask_question_list')
  },
  {
    path: '/ask_question_chat',
    name: '问题详情',
    component: () => import('@/pages/ask/ask_question_chat')
  },
  {
    path: '/ask_question_detail',
    name: '问题详情',
    component: () => import('@/pages/ask/ask_question_detail')
  },
  {
    path: '/ask_consult',
    name: '图文咨询',
    component: () => import('@/pages/ask/ask_consult')
  },
  {
    path: '/ask_depart_list',
    name: '科室选择',
    component: () => import('@/pages/ask/ask_depart_list')
  },
  // 个人中心
  {
    path: '/ask_center',
    name: '个人中心',
    component: () => import('@/pages/ask/ask_center')
  },
  {
    path: '/ask_my_questions',
    name: '我的问题',
    component: () => import('@/pages/ask/ask_my_questions')
  },
  {
    path: '/ask_continue_question',
    name: '追问',
    component: () => import('@/pages/ask/ask_continue_question')
  },
  {
    path: '/ask_add_information',
    name: '补充资料',
    component: () => import('@/pages/ask/ask_add_information')
  },
  {
    path: '/ask_my_income',
    name: '我的收益',
    component: () => import('@/pages/ask/ask_my_income')
  },
  {
    path: '/ask_my_follow_group',
    name: '我关注的医师',
    component: () => import('@/pages/ask/ask_my_follow_group')
  },
  {
    path: '/ask_my_crowded',
    name: '我围观的问题',
    component: () => import('@/pages/ask/ask_my_crowded')
  },
  {
    path: '/ask_comment_doctor',
    name: '评价医生',
    component: () => import('@/pages/ask/ask_comment_doctor')
  },
  {
    path: '/ask_comment_detail',
    name: '评价详情',
    component: () => import('@/pages/ask/ask_comment_detail')
  },
  {
    path: '/ask_service_list',
    name: '服务包列表',
    component: () => import('@/pages/ask/ask_service_list')
  },
  {
    path: '/ask_service_detail',
    name: '服务包详情',
    component: () => import('@/pages/ask/ask_service_detail')
  },
  {
    path: '/ask_service_detail_form',
    name: '患者信息填写',
    component: () => import('@/pages/ask/ask_service_detail_form')
  },
  {
    path: '/ask_service_package',
    name: '历史记录',
    component: () => import('@/pages/ask/ask_service_package')
  },
  {
    path: '/ask_quick_ask',
    name: '快问快答',
    component: () => import('@/pages/ask/ask_quick_ask')
  },
  {
    path: '/ask_use_pharmacy',
    name: '用药咨询',
    component: () => import('@/pages/ask/ask_use_pharmacy')
  },
  {
    path: '/ask_medicine',
    name: '用药咨询医生列表',
    component: () => import('@/pages/ask/ask_medicine')
  },
  {
    path: '/ask_help_test',
    name: '爱心助考',
    component: () => import('@/pages/ask/ask_help_test')
  },
  {
    path: '/ask_pelvic',
    name: '女性盆底健康专区',
    component: () => import('@/pages/ask/ask_pelvic')
  },
  {
    path: '/ask_pelvic_new',
    name: '女性盆底健康专区',
    component: () => import('@/pages/ask/ask_pelvic_new')
  },
  {
    path: '/pelvic_doctor',
    name: '子宫脱落',
    component: () => import('@/pages/ask/pelvic_doctor')
  },
  {
    path: '/ask_more_pelvic',
    name: '女性盆底咨询',
    component: () => import('@/pages/ask/ask_more_pelvic')
  },
  {
    path: '/ask_history_illness',
    name: '历史病情',
    component: () => import('@/pages/ask/ask_history_illness')
  },
  {
    path: '/ask_hospital_doclist',
    name: '医生列表',
    component: () => import('@/pages/ask/ask_hospital_doclist')
  }, //ask_diabetes_investigation
  {
    path: '/ask_diabetes_investigation',
    name: '患者信息填写',
    component: () => import('@/pages/ask/ask_diabetes_investigation')
  },
  {
    path: '/ask_choose_depart',
    name: '科室选择',
    component: () => import('@/pages/ask/ask_choose_depart')
  }
]

export default ask
